<sona-favicon [url]="target().url" [size]="16" />
<span class="text-truncate">{{ target().name }}</span>
